import { Box, SxProps, TextField, Theme } from '@mui/material';
import { FormikProps } from 'formik';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RECEIVER_EMAIL, RECEIVER_FIRST_NAME, RECEIVER_LAST_NAME, RECEIVER_PHONE } from '../../constants/shipping';
import useWindowSize from '../../hooks/useWindowSize';
import { selectIsDigital } from '../../store/selectors/init';
import { IContactInfo } from '../../types/api';
import { Title } from '../_mui';

interface IProps {
  form: FormikProps<Partial<IContactInfo>>;
  title?: string;
}

const ContactForm = ({ form, title }: IProps) => {
  const { mobile } = useWindowSize();
  const isDigital = useSelector(selectIsDigital);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.value && Object.keys(form.errors).length) {
        form.setTouched({});
        form.setErrors({});
      }
      form.handleChange(e);
    },
    [form.handleChange, form.setTouched, form.errors],
  );

  const formStyles: SxProps<Theme> = useMemo(() => {
    return mobile
      ? { display: 'flex', flexDirection: 'column', rowGap: 3 }
      : { display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: 3, columnGap: 2 };
  }, [mobile]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {title && <Title>{title}</Title>}
      <Box sx={formStyles}>
        <TextField
          required
          type="text"
          label="First name"
          name={RECEIVER_FIRST_NAME}
          onChange={handleChange}
          onBlur={form.handleBlur}
          error={form.touched[RECEIVER_FIRST_NAME] ? !!form.errors[RECEIVER_FIRST_NAME] : false}
          value={form.values[RECEIVER_FIRST_NAME] || ''}
          fullWidth
          size="medium"
          helperText={form.touched[RECEIVER_FIRST_NAME] ? form.errors[RECEIVER_FIRST_NAME] : undefined}
        />
        <TextField
          required
          type="text"
          label="Last name"
          name={RECEIVER_LAST_NAME}
          onChange={handleChange}
          onBlur={form.handleBlur}
          error={form.touched[RECEIVER_LAST_NAME] ? !!form.errors[RECEIVER_LAST_NAME] : false}
          value={form.values[RECEIVER_LAST_NAME] || ''}
          fullWidth
          size="medium"
          helperText={form.touched[RECEIVER_LAST_NAME] ? form.errors[RECEIVER_LAST_NAME] : undefined}
        />
        <TextField
          required={!isDigital}
          type="text"
          label="Phone"
          name={RECEIVER_PHONE}
          onChange={handleChange}
          onBlur={form.handleBlur}
          error={form.touched[RECEIVER_PHONE] ? !!form.errors[RECEIVER_PHONE] : false}
          value={form.values[RECEIVER_PHONE] || ''}
          fullWidth
          size="medium"
          helperText={form.touched[RECEIVER_PHONE] ? form.errors[RECEIVER_PHONE] : undefined}
        />
        <TextField
          required
          type="text"
          label="Email"
          name={RECEIVER_EMAIL}
          onChange={handleChange}
          onBlur={form.handleBlur}
          error={form.touched[RECEIVER_EMAIL] ? !!form.errors[RECEIVER_EMAIL] : false}
          value={form.values[RECEIVER_EMAIL] || ''}
          fullWidth
          size="medium"
          helperText={form.touched[RECEIVER_EMAIL] ? form.errors[RECEIVER_EMAIL] : undefined}
        />
      </Box>
    </Box>
  );
};

export default ContactForm;
